/**
 * OEBAK-Teilnehmer
 * REST-Endpoints fuer Teilnehmer-Applikation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ClientLogVO { 
    severity?: ClientLogVO.SeverityEnum;
    message?: string;
    stacktrace?: string;
    url?: string;
    clazz?: string;
}
export namespace ClientLogVO {
    export type SeverityEnum = 'INFO' | 'WARN' | 'ERROR';
    export const SeverityEnum = {
        INFO: 'INFO' as SeverityEnum,
        WARN: 'WARN' as SeverityEnum,
        ERROR: 'ERROR' as SeverityEnum
    };
}


